var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-center justify-center bg-white rounded cursor-pointer w-28 h-7 hover:bg-gray-100",class:{ 'bg-gray-200': _vm.active },on:{"click":function($event){return _vm.checkTab(_vm.title)}}},[_c('p',{class:{
      'font-semibold text-tahiti-500': _vm.textAttributes,
      'underline': _vm.active
    },domProps:{"textContent":_vm._s(_vm.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }